import { ArrowRight, PhoneCall } from "lucide-react";
import { Button } from "@/components/ui/button";

export function PageHero({ eyebrow, title, description, imageUrl, primaryHref, primaryLabel, phone, testIdPrefix }) {
  return (
    <section className="px-4 md:px-6" data-testid={`${testIdPrefix}-section`}>
      <div className="page-section grid gap-8 lg:grid-cols-[1.05fr_0.95fr] lg:items-center">
        <div className="space-y-6">
          <p className="text-sm font-semibold uppercase tracking-[0.28em] text-primary" data-testid={`${testIdPrefix}-eyebrow`}>
            {eyebrow}
          </p>
          <h1 className="text-4xl font-bold text-foreground sm:text-5xl lg:text-6xl" data-testid={`${testIdPrefix}-title`}>
            {title}
          </h1>
          <p className="max-w-2xl text-sm text-muted-foreground md:text-base" data-testid={`${testIdPrefix}-description`}>
            {description}
          </p>
          <div className="flex flex-wrap gap-3">
            <Button asChild className="rounded-full px-6 py-6 text-sm">
              <a data-testid={`${testIdPrefix}-primary-button`} href={primaryHref}>
                {primaryLabel}
                <ArrowRight className="h-4 w-4" />
              </a>
            </Button>
            <Button asChild className="rounded-full px-6 py-6 text-sm" variant="outline">
              <a data-testid={`${testIdPrefix}-phone-button`} href={`tel:${phone}`}>
                <PhoneCall className="h-4 w-4" />
                {phone}
              </a>
            </Button>
          </div>
        </div>

        <div className="image-shell aspect-[5/4] overflow-hidden rounded-[2rem]" data-testid={`${testIdPrefix}-image-shell`}>
          <img alt={title} className="h-full w-full object-cover" data-testid={`${testIdPrefix}-image`} src={imageUrl} />
        </div>
      </div>
    </section>
  );
}